import type { FilterOption } from './types'

export interface ChoiceNode {
  id: string | number
  label: string
  children?: ChoiceNode[]
}

/** Keep the path for chips and the hierarchy for the dropdown. */
export function flattenChoices(items: ChoiceNode[], ancestors: string[] = [], path: string[] = []): FilterOption[] {
  return items.flatMap(item => {
    const value = String(item.id)
    const names = [...path, item.label]
    return [{ value, label: names.join(' / '), nodeLabel: item.label, ancestors, hasChildren: !!item.children?.length },
      ...flattenChoices(item.children || [], [...ancestors, value], names)]
  })
}

export function visibleChoiceIds(options: FilterOption[], expanded: string[], searching: boolean): Set<string> {
  const opened = new Set(expanded)
  return new Set(options.filter(item => searching || (item.ancestors || []).every(id => opened.has(id))).map(item => item.value))
}

/** Cached selections must not change the order or ancestry of the current page. */
export function retainChoiceLabels(current: FilterOption[], cached: FilterOption[]): FilterOption[] {
  const ids = new Set(current.map(item => item.value))
  return [...current, ...cached.filter(item => !ids.has(item.value))]
}

/** The choices API uses page numbers for trees and cursors for flat directories. */
export function choiceContinuation(next: string | null | undefined): string | null {
  if (!next) return null
  const query = new URL(next, 'https://localhost').searchParams
  for (const key of ['cursor', 'page']) {
    const value = query.get(key)
    if (value) return new URLSearchParams({ [key]: value }).toString()
  }
  return null
}
